import React, { useEffect, useState } from 'react';
import {
	ChakraProvider,
	theme,
	Box,
	Image,
	Menu,
	MenuList,
	MenuItem,
	useColorModeValue,
} from '@chakra-ui/react';
import { Login } from '../Login';
import { Invite } from '../Invite';
import { User } from './user';
import { Admin } from './admin';

import { ui } from '../ui-kit';
import { getUser } from './auth';
import { adminPic, sessionKey } from './data';

const { CenterFlex, HorStack, SmAvatar, TopBox, TopFlex, UserButton } =
	ui(useColorModeValue);

function App({ search }) {
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState({});
	useEffect(() => {
		let active = true;
		async function load() {
			const res = await getUser(search);
			if (!active) {
				return;
			}
			setLoading(false);
			setUser(res);
		}
		load();

		return () => {
			active = false;
		};
	}, [search]);

	if (loading) return <p>Loading...</p>;
	localStorage.setItem(sessionKey, user.session)

	const roles = {
		invite: <Invite {...{ setUser, search }} />,
		guest: <Login {...{ setUser }} />,
		admin: <Admin {...{ user }} />,
		customer: <User {...{ user }} />,
	};

	return (
		<ChakraProvider theme={theme}>
			<TopBox>
				<TopFlex>
					<HorStack
						bgColor="white"
						px={4}
						sx={{
							'@media print': {
								display: 'none',
							},
						}}
					>
						<Box bgColor="#ed3c42">
							<Image src="/logo_canadamania.png" alt="CanadaMania logo" />
						</Box>
					</HorStack>
					<CenterFlex>
						{user.role === 'admin' && (
							<Menu>
								<UserButton>
									<SmAvatar {...{ adminPic }} />
								</UserButton>
								<MenuList>
									<MenuItem>Выйти</MenuItem>
								</MenuList>
							</Menu>
						)}
					</CenterFlex>
				</TopFlex>
			</TopBox>
			{roles[user.role]}
		</ChakraProvider>
	);
}

export default App;
